import { createFileRoute } from "@tanstack/react-router"
import Tv from "~/pages/tv"

export const Route = createFileRoute("/_auth/internal/tv")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <Tv />
}
